
export class AuthData {
    id: number;
    codigoUsuario: number;
    emailUsuario: string;
    nomeUsuario: string;
    codigoEmpresa: number;
    nomeEmpresa: string;
    indTipoUsuario: number;
    indAtivo: boolean;
    loginUsuario: string;
    tokenApp: string;
    tokenBackEnd: string | undefined;
    dataHoraLogin: Date;
    dataHoraValidade: Date;
    userAgent: string;
    rowid: string;
    isAdministrador: boolean = false;
    isFuncionario: boolean = false;
    isCoordenador: boolean = false;
    isTerceiro: boolean = false;

    constructor(object?) {
        var self = this;
        if (object) {
            Object.keys(object).forEach(function (k) {
                self[k] = object[k];
            });
        }
    }

}
